import BHRating from '../../../molecules/rating'
import { useIntl } from 'react-intl'
import { number, object } from 'prop-types'
import { Root, Anchor } from './rating.styled'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useUser } from '@bluheadless/ui-logic/src/providers/user'
import { useScrollTo } from '@bluheadless/ui-logic/src/hooks/useScrollTo'
import { cx } from '@emotion/css'

const Rating = ({ count, summary, reviewsRef, className }) => {
	const { formatMessage } = useIntl()

	const {
		catalog: {
			products: {
				rating: { enabled, guest: guestEnabled },
			},
		},
	} = useConfig()
	const [{ isLoggedIn }] = useUser()
	const { manageScroll } = useScrollTo()

	return (
		enabled && (
			<Root className={cx('Rating-root', className)} display="flex" alignItems="center" flexWrap="wrap">
				<BHRating value={count} readOnly />
				<Anchor color="grey.main" onClick={() => manageScroll({ ref: reviewsRef })}>
					{summary > 0
						? `(${summary}) ${formatMessage({ id: 'read_reviews' })}`
						: isLoggedIn || guestEnabled
						? formatMessage({ id: 'no_reviews' })
						: null}
				</Anchor>
			</Root>
		)
	)
}

Rating.propTypes = {
	count: number,
	summary: number,
	reviewsRef: object,
}

export default Rating
